import { Box, Stack } from '@mui/material';

interface StickyBlockProps {
  children: React.ReactNode;
}

const StickyBlock = ({ children }: StickyBlockProps) => {
  return (
    <Box maxWidth={256} minWidth={128} sx={{ position: 'relative', top: -16 }}>
      <Stack
        spacing={2}
        pt={2}
        sx={{
          position: 'sticky',
          top: 0,
          alignSelf: 'flex-start',
        }}
      >
        {children}
      </Stack>
    </Box>
  );
};

export default StickyBlock;
